import React from 'react'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import { media, rhythm, color } from '../utils/typography'

import Container from './container'
import LanguageSwitcher from './language-switcher'
import Link from './link'

export default styled(withTranslation()(({ className, t }) =>
  <header className={className}>
    <Container className='container'>
      <Link className='standalone brand' to='/'>{t('brand')}</Link>

      <ul className='inline-list links'>
        <li><Link className='brand' to='/'>{t('brand')}</Link></li>
        <li><Link to='/extradition'>{t('extradition.link')}</Link></li>
        <li><Link to='/extradition/map'>{t('extradition.map.link')}</Link></li>
        <li><Link to='/nsl-statement'>{t('nsl.link')}</Link></li>
      </ul>

      <LanguageSwitcher className='switcher' />
    </Container>
  </header>
))`
  padding: ${rhythm(1/2)} 0;
  ${media.desktop} { padding: ${rhythm(1)} 0; }

  a {
    &, &:hover, &:active, &:focus, &:visited {
      color: ${color.body};
    }
  }

  .container {
    position: relative;
    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: space-between;
  }

  .brand {
    font-weight: bold;
    &.standalone {
      width: 100%;
      text-align: center;
      font-size: ${rhythm(3/4)};
      ${media.tablet} { display: none; }
    }
  }

  .links {
    display: none;
    ${media.tablet} { display: block; }
  }

  .switcher {
    display: none;
    ${media.tablet} { display: block; }
    margin: 0;
    padding: 0;
    color: ${color.header};
  }
`
